var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard settings"},[(_vm.isEmbedModalOpen)?_c('div',{staticClass:"embed__background",on:{"click":_vm.closeModal}}):_vm._e(),_c('Header'),(_vm.isMounted)?_c('LiveSettings'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }